import React, { useState, useEffect, useRef } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { motion, AnimatePresence } from "framer-motion";
import AZ from '../../assets/logos/az.png';
import './GalerieSectionA.css';

const colors = {
  goldLight: '#F5E1C8',
  gold: '#C69C6D',
  goldDark: '#B88A56',
  text: '#3B2F2A',
  textSoft: '#5C4A3D',
  glassBg: 'rgba(255, 255, 255, 0.7)',
  glassBorder: 'rgba(198, 156, 109, 0.25)',
  shadow: '0 8px 24px rgba(107, 90, 70, 0.06)',
  shadowHover: '0 16px 32px rgba(184, 138, 86, 0.15)',
};

const ITEMS_PER_PAGE = 24;

const GalerieSectionA = () => {
  // Base d'images complète : série B (1 à 66), série A (1 à 45), puis les autres
  const images = [
    // Série B (b1 à b66)
    "img2/b1.jpeg", "img2/b2.jpeg", "img2/b3.jpeg", "img2/b4.jpeg", "img2/b5.jpeg", "img2/b6.jpeg",
    "img2/b7.jpeg", "img2/b8.jpeg", "img2/b9.jpeg", "img2/b10.jpeg", "img2/b11.jpeg", "img2/b12.jpeg",
    "img2/b13.jpeg", "img2/b14.jpeg", "img2/b15.jpeg", "img2/b16.jpeg", "img2/b17.jpeg", "img2/b18.jpeg",
    "img2/b19.jpeg", "img2/b20.jpeg", "img2/b21.jpeg", "img2/b22.jpeg", "img2/b23.jpeg", "img2/b24.jpeg",
    "img2/b25.jpeg", "img2/b26.jpeg", "img2/b27.jpeg", "img2/b28.jpeg", "img2/b29.jpeg", "img2/b30.jpeg",
    "img2/b31.jpeg", "img2/b32.jpeg", "img2/b33.jpeg", "img2/b34.jpeg", "img2/b35.jpeg",
    "img2/b36.jpeg", "img2/b37.jpeg", "img2/b38.jpeg", "img2/b39.jpeg", "img2/b40.jpeg",
    "img2/b41.jpeg", "img2/b42.jpeg", "img2/b43.jpeg", "img2/b44.jpeg", "img2/b45.jpeg",
    "img2/b46.jpeg", "img2/b47.jpeg", "img2/b48.jpeg", "img2/b49.jpeg", "img2/b50.jpeg",
    "img2/b51.jpeg", "img2/b52.jpeg", "img2/b53.jpeg", "img2/b54.jpeg", "img2/b55.jpeg",
    "img2/b56.jpeg", "img2/b57.jpeg", "img2/b58.jpeg", "img2/b59.jpeg", "img2/b60.jpeg",
    "img2/b61.jpeg", "img2/b62.jpeg", "img2/b63.jpeg", "img2/b64.jpeg", "img2/b65.jpeg", "img2/b66.jpeg",
    // Série A (a1 à a45)
    "img2/a1.jpeg", "img2/a2.jpeg", "img2/a3.jpeg", "img2/a4.jpeg", "img2/a5.jpeg", "img2/a6.jpeg",
    "img2/a7.jpeg", "img2/a8.jpeg", "img2/a9.jpeg", "img2/a10.jpeg", "img2/a11.jpeg", "img2/a12.jpeg",
    "img2/a13.jpeg", "img2/a14.jpeg", "img2/a15.jpeg", "img2/a16.jpeg", "img2/a17.jpeg", "img2/a18.jpeg",
    "img2/a19.jpeg", "img2/a20.jpeg", "img2/a21.jpeg", "img2/a22.jpeg", "img2/a23.jpeg", "img2/a24.jpeg",
    "img2/a25.jpeg", "img2/a26.jpeg", "img2/a27.jpeg", "img2/a28.jpeg", "img2/a29.jpeg", "img2/a30.jpeg",
    "img2/a32.jpeg", "img2/a33.jpeg", "img2/a34.jpeg", "img2/a35.jpeg", "img2/a36.jpeg",
    "img2/a37.jpeg", "img2/a38.jpeg", "img2/a39.jpeg", "img2/a40.jpeg", "img2/a41.jpeg", "img2/a42.jpeg",
    "img2/a43.jpeg", "img2/a45.jpeg", "img2/a40.jpeg", "img2/a41.jpeg", "img2/a42.jpeg",
    // Autres images mélangées
    "img2/1.jpeg", "img2/2.jpeg", "img2/3.jpg", "img2/4.jpeg", "img2/9.jpeg", "img2/10.jpeg",
    "img2/13.jpeg", "img2/5.jpg", "img2/6.jpeg", "img2/7.jpg", "img2/8.jpeg", "img2/21.jpg",
    "img2/18.jpg", "img2/11.jpeg", "img2/12.jpeg", "img2/19.jpg", "img2/20.jpg", "img2/17.jpeg",
    "img2/14.jpeg", "img2/15.jpg", "img2/16.jpg", "img2/22.jpg", "img2/23.jpg", "img2/24.jpeg",
    "img2/25.jpg", "img2/26.jpg", "img2/33.jpg", "img2/34.jpg", "img2/35.jpg", "img2/36.jpg",
    "img2/37.jpeg", "img2/38.jpeg", "img2/29.jpeg", "img2/30.jpeg", "img2/39.jpg", "img2/40.jpg",
    "img2/41.jpg", "img2/42.jpeg", "img2/43.jpg", "img2/44.jpg", "img2/45.jpeg", "img2/46.jpg",
    "img2/31.jpeg", "img2/32.jpeg", "img2/320.jpg", "img2/330.jpeg", "img2/350.jpg", "img2/340.jpeg",
    "img2/110.jpg", "img2/111.jpg", "img2/112.jpg", "img2/113.jpg", "img2/114.jpg", "img2/115.jpg",
    "img2/360.jpg", "img2/370.jpeg", "img2/390.jpeg", "img2/380.jpeg", "img2/400.jpeg", "img2/410.jpeg",
    "img2/210.jpeg", "img2/211.jpeg", "img2/216.jpg", "img2/213.jpeg", "img2/214.jpg", "img2/215.jpg",
    "img2/444.jpeg", "img2/445.jpeg", "img2/446.jpeg", "img2/447.jpeg", "img2/448.jpeg", "img2/449.png",
    "img2/500.jpeg", "img2/501.jpeg", "img2/502.jpeg", "img2/503.jpg", "img2/504.jpg", "img2/505.jpg",
    "img2/506.jpg", "img2/508.jpg", "img2/509.jpg", "img2/510.jpg", "img2/511.jpg", "img2/512.jpg",
    "img2/513.jpg", "img2/514.jpg", "img2/515.jpg", "img2/516.jpg", "img2/517.jpg", "img2/518.jpg",
    "img2/519.jpg", "img2/520.jpg", "img2/521.jpg", "img2/522.jpg", "img2/523.jpg", "img2/524.jpg",
    "img2/525.jpg", "img2/526.jpg", "img2/527.jpg", "img2/528.jpg", "img2/529.jpg", "img2/530.jpg",
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(images.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const visibleImages = images.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const currentPageRef = useRef(currentPage);
  useEffect(() => {
    currentPageRef.current = currentPage;
  }, [currentPage]);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  const openLightbox = (indexInPage) => {
    const page = currentPageRef.current;
    const globalIndex = (page - 1) * ITEMS_PER_PAGE + indexInPage;
    setPhotoIndex(globalIndex);
    setIsOpen(true);
  };

  const goToPage = (page) => {
    const newPage = Math.max(1, Math.min(page, totalPages));
    setCurrentPage(newPage);
    document.querySelector('.galerie-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const nextPage = () => goToPage(currentPage + 1);
  const prevPage = () => goToPage(currentPage - 1);

  const getPageNumbers = () => {
    const delta = 2;
    const range = [];
    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - delta && i <= currentPage + delta)) {
        range.push(i);
      }
    }
    const result = [];
    range.forEach((page, idx) => {
      if (idx > 0 && page - range[idx - 1] !== 1) {
        result.push('...');
      }
      result.push(page);
    });
    return result;
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#FDF8F0'
      }}>
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.6, repeat: Infinity, repeatType: 'mirror' }}
          style={{
            width: '4rem',
            height: '4rem',
            border: '4px solid #C69C6D',
            borderTopColor: 'transparent',
            borderRadius: '50%',
          }}
        />
      </div>
    );
  }

  return (
    <>
      <style>{`
        .galerie-section {
          position: relative;
          padding: 80px 0;
          background: linear-gradient(135deg, #EAD5C0 0%, #D4B895 30%, #C69C6D 60%, #E8CFB5 100%);
          background-size: 400% 400%;
          animation: goldGradient 15s ease infinite;
          overflow: hidden;
          min-height: 100vh;
        }
        @keyframes goldGradient {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .galerie-section::before,
        .galerie-section::after {
          content: '';
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          opacity: 0.3;
          z-index: 0;
          pointer-events: none;
        }
        .galerie-section::before {
          width: 50vw; height: 50vw;
          background: #F5E1C8;
          top: -10%; left: -5%;
          animation: floatOrb 18s ease-in-out infinite;
        }
        .galerie-section::after {
          width: 40vw; height: 40vw;
          background: #E8CFB5;
          bottom: -8%; right: -4%;
          animation: floatOrb 15s ease-in-out infinite alternate-reverse;
        }
        @keyframes floatOrb {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(5%, 10%) scale(1.15); }
          100% { transform: translate(-5%, 5%) scale(0.9); }
        }
        .container-galerie {
          position: relative;
          z-index: 2;
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 24px;
        }
        .logo-galerie {
          display: flex;
          justify-content: center;
          margin-bottom: 20px;
        }
        .logo-galerie img {
          width: 220px;
          filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));
        }
        .galerie-title {
          font-size: clamp(2rem, 5vw, 2.8rem);
          font-weight: 700;
          color: ${colors.text};
          text-align: center;
          margin-bottom: 0.5rem;
          letter-spacing: -0.5px;
        }
        .title-underline {
          width: 80px;
          height: 3px;
          background: linear-gradient(90deg, ${colors.goldDark}, ${colors.gold});
          margin: 0 auto 40px;
          border-radius: 2px;
        }
        .grid-galerie {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 16px;
        }
        .image-card {
          position: relative;
          border-radius: 16px;
          overflow: hidden;
          background: ${colors.glassBg};
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border: 1px solid ${colors.glassBorder};
          box-shadow: ${colors.shadow};
          transition: all 0.3s ease;
          cursor: pointer;
          aspect-ratio: 1 / 1;
        }
        .image-card:hover {
          transform: translateY(-6px);
          box-shadow: ${colors.shadowHover};
          border-color: ${colors.gold};
        }
        .image-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        .image-card:hover img {
          transform: scale(1.08);
        }
        .image-card .overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(198,156,109,0.25), rgba(198,156,109,0.1));
          opacity: 0;
          transition: opacity 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .image-card:hover .overlay {
          opacity: 1;
        }
        /* Icône loupe au survol */
        .overlay::after {
          content: "🔍";
          font-size: 2rem;
          color: white;
          text-shadow: 0 2px 6px rgba(0,0,0,0.4);
          transform: scale(0.8);
          transition: transform 0.3s ease;
          opacity: 0.9;
        }
        .image-card:hover .overlay::after {
          transform: scale(1);
        }
        /* Pagination */
        .pagination-container {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 48px;
          gap: 6px;
          flex-wrap: wrap;
        }
        .pagination-btn {
          background: ${colors.glassBg};
          backdrop-filter: blur(8px);
          border: 1px solid ${colors.glassBorder};
          color: ${colors.text};
          min-width: 44px;
          height: 44px;
          padding: 0 8px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-weight: 600;
          font-size: 1rem;
          transition: all 0.2s ease;
          box-shadow: 0 2px 8px rgba(107, 90, 70, 0.05);
          user-select: none;
        }
        .pagination-btn:hover:not(:disabled) {
          background: ${colors.goldLight};
          border-color: ${colors.gold};
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(184, 138, 86, 0.2);
        }
        .pagination-btn.active {
          background: ${colors.gold};
          color: white;
          border-color: ${colors.goldDark};
          box-shadow: 0 4px 12px rgba(184, 138, 86, 0.3);
          transform: scale(1.08);
        }
        .pagination-btn:disabled {
          opacity: 0.4;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }
        .pagination-arrow {
          font-size: 1.4rem;
          line-height: 1;
        }
        .pagination-ellipsis {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          color: ${colors.textSoft};
          font-weight: 600;
        }
        /* Badge numéro d'image */
        .image-count-badge {
          position: absolute;
          bottom: 8px;
          right: 8px;
          background: rgba(0,0,0,0.5);
          backdrop-filter: blur(4px);
          color: white;
          font-size: 0.75rem;
          padding: 4px 10px;
          border-radius: 20px;
          opacity: 0.6;
          transition: opacity 0.3s ease;
          pointer-events: none;
          z-index: 2;
        }
        .image-card:hover .image-count-badge {
          opacity: 1;
        }
        /* Compteur total d'images */
        .total-images {
          text-align: center;
          color: ${colors.textSoft};
          font-size: 0.95rem;
          margin-bottom: 24px;
          font-weight: 500;
        }
        @media (max-width: 768px) {
          .grid-galerie {
            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
            gap: 12px;
          }
          .pagination-btn {
            min-width: 38px;
            height: 38px;
            border-radius: 10px;
            font-size: 0.9rem;
            padding: 0 6px;
          }
          .pagination-ellipsis {
            width: 38px;
            height: 38px;
          }
        }
      `}</style>

      <section className="galerie-section">
        <div className="container-galerie">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="logo-galerie"
          >
            <img src={AZ} alt="Azyekos Logo" />
          </motion.div>

          <motion.h1
            className="galerie-title"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
          >
            GALERIE
          </motion.h1>
          <motion.div
            className="title-underline"
            initial={{ width: 0 }}
            animate={{ width: 80 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          />
          <motion.p
            style={{ textAlign: 'center', color: colors.textSoft, fontSize: '1.2rem', marginBottom: '8px' }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.6 }}
          >
            NOS ÉVÉNEMENTS
          </motion.p>
          <motion.p
            className="total-images"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6, duration: 0.6 }}
          >
            {images.length} photos
          </motion.p>

          <div style={{ minHeight: '400px' }}>
            <AnimatePresence mode="wait">
              <motion.div
                key={currentPage}
                className="grid-galerie"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.25 }}
              >
                {visibleImages.map((src, index) => (
                  <motion.div
                    key={`${currentPage}-${index}`}
                    className="image-card"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.02 }}
                    onClick={() => openLightbox(index)}
                  >
                    <img src={src} alt={`Galerie ${startIndex + index + 1}`} loading="lazy" />
                    <div className="overlay" />
                    <span className="image-count-badge">
                      {startIndex + index + 1}/{images.length}
                    </span>
                  </motion.div>
                ))}
              </motion.div>
            </AnimatePresence>
          </div>

          {totalPages > 1 && (
            <motion.div
              className="pagination-container"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.5 }}
            >
              <button
                className="pagination-btn"
                onClick={() => goToPage(1)}
                disabled={currentPage === 1}
                aria-label="Première page"
              >
                <span className="pagination-arrow">«</span>
              </button>
              <button
                className="pagination-btn"
                onClick={prevPage}
                disabled={currentPage === 1}
                aria-label="Page précédente"
              >
                <span className="pagination-arrow">‹</span>
              </button>

              {getPageNumbers().map((item, idx) =>
                item === '...' ? (
                  <span key={`dots-${idx}`} className="pagination-ellipsis">…</span>
                ) : (
                  <button
                    key={item}
                    className={`pagination-btn ${item === currentPage ? 'active' : ''}`}
                    onClick={() => goToPage(item)}
                  >
                    {item}
                  </button>
                )
              )}

              <button
                className="pagination-btn"
                onClick={nextPage}
                disabled={currentPage === totalPages}
                aria-label="Page suivante"
              >
                <span className="pagination-arrow">›</span>
              </button>
              <button
                className="pagination-btn"
                onClick={() => goToPage(totalPages)}
                disabled={currentPage === totalPages}
                aria-label="Dernière page"
              >
                <span className="pagination-arrow">»</span>
              </button>
            </motion.div>
          )}
        </div>
      </section>

      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + images.length - 1) % images.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % images.length)
          }
        />
      )}
    </>
  );
};

export default GalerieSectionA;